export interface ApiError {
  status: number;
  code: string;
  message: string;
  traceId: string;
  /**
   * Solo presente en errores de bean validation del backend (400 VALIDATION_ERROR):
   * mapa campo → mensaje con TODOS los campos inválidos del body.
   */
  fieldErrors?: Record<string, string>;
}

/**
 * Angular reporta con status 0 los fallos donde el backend nunca respondió
 * (red caída, CORS, DNS): ahí no hay message del servidor que valga la pena mostrar.
 */
export function isNetworkFailure(error: ApiError): boolean {
  return error.status === 0;
}
